import React, { useEffect } from 'react';
import { store } from 'redux/store';
import { setCurrentTab } from 'redux/reducers/weatherLayoutReducer';
import ImageDisplay from 'components/Meteorology/Weather/Comparator/ImageDisplay';
import SeasonalComparatorToolbar from 'components/Meteorology/Weather/Comparator/Toolbar';
import ComparatorMobile from 'components/Meteorology/Weather/Comparator/Mobile';
import useImages from 'hooks/Meteorology/Weather/Comparator/useImages';
import useImagesDownload from 'hooks/Meteorology/Weather/Comparator/useImagesDownload';
import useIsMobile from 'utils/hooks/useIsMobile';

export default function Comparator() {
  const isMobile = useIsMobile();

  useEffect(() => {
    store.dispatch(setCurrentTab('comparator'));
  }, []);
  const {
    images, queryError, onRetry, loading,
  } = useImages();
  const { onDownloadClick, downloadDisabled } = useImagesDownload(images, loading);

  if (isMobile) {
    return (
      <ComparatorMobile
        images={images}
        queryError={queryError}
        onRetry={onRetry}
        loading={loading}
        onDownloadClick={onDownloadClick}
        downloadDisabled={downloadDisabled}
      />
    );
  }

  return (
    <div className="p-4">
      <div className="d-md-flex justify-content-end align-items-center">
        <SeasonalComparatorToolbar
          downloadDisabled={downloadDisabled}
          onDownloadClick={onDownloadClick}
        />
      </div>
      <ImageDisplay
        images={images}
        queryError={queryError}
        onRetry={onRetry}
        loading={loading}
      />
    </div>
  );
}
